import ProjectBaseModel from "stores/projects/models/ProjectBaseModel";
import RouteEnum from "../../../../constants/RouteEnum";
import ProjectGenresModel from "../../models/ProjectGenresModel";

export default class MovieProjectModel extends ProjectBaseModel {
  public movie_type: string = "";
  public readonly scriptwriter: string = "";
  public readonly music: string = "";
  public readonly genres: ProjectGenresModel[] = [ProjectGenresModel as any];
  public readonly get_create_path: string = "";
  public readonly get_update_path: string = "";

  constructor(movie_project_model: Partial<MovieProjectModel>) {
    super(movie_project_model);
    this.get_create_path = get_create_path();
    this.get_update_path = get_update_path(movie_project_model?.slug ?? "");
    this.update(movie_project_model);
  }
}

const get_create_path = (): string => {
  return RouteEnum.MovieCreate;
};

const get_update_path = (slug: string): string => {
  return RouteEnum.MovieUpdate.replace(":slug", slug);
};
